import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface NegativeCommentsMetrics {
  negativeCount: number;
  totalCount: number;
  percentage: number;
  negativeResponses: Array<{
    id: string;
    rating: number;
    comment: string | null;
    page_name: string;
    created_at: string;
  }>;
}

export const useCSATNegativeComments = (daysRange: number = 30) => {
  return useQuery({
    queryKey: ['csat-negative-comments', daysRange],
    queryFn: async (): Promise<NegativeCommentsMetrics> => {
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - daysRange);

      const { data, error } = await supabase
        .from('csat_responses')
        .select('id, rating, comment, page_name, created_at')
        .gte('created_at', startDate.toISOString())
        .order('created_at', { ascending: false });

      if (error) throw error;

      const totalCount = data?.length || 0;
      const negativeResponses = data?.filter(r => r.rating <= 2) || [];
      const negativeCount = negativeResponses.length;
      const percentage = totalCount > 0 
        ? Math.round((negativeCount / totalCount) * 100 * 10) / 10 
        : 0;

      return {
        negativeCount,
        totalCount,
        percentage,
        negativeResponses: negativeResponses.map(r => ({
          id: r.id,
          rating: r.rating,
          comment: r.comment,
          page_name: r.page_name || 'Desconhecida',
          created_at: r.created_at,
        })),
      };
    },
  });
};

